import MoodIcon from '@mui/icons-material/Mood';

export const Awesome = ({ color }) => (
  <MoodIcon fontSize="large" sx={{ color }} />
);
